import React, { useEffect, useState, useCallback } from "react";
import { Toaster } from "react-hot-toast";
import Sidebar from "./components/Sidebar";
import MessageDetail from "./components/MessageDetail";
import Login from "./components/Login";
import "./App.css";

function App() {
  const [allMessages, setAllMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [filterCompleted, setFilterCompleted] = useState(false);
  const [filterSpam, setFilterSpam] = useState(false);
  const [filterLeads, setFilterLeads] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const loadAll = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const headers = { Authorization: `Bearer ${token}` };
    const res = await fetch(`/api/messages?show_completed=true`, { headers });

    if (res.status === 401) {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
      return;
    }

    const msgs = await res.json();
    setAllMessages(msgs);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
    if (token) loadAll();
  }, [loadAll]);

  const handleLogin = () => {
    setIsAuthenticated(true);
    loadAll();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
  };

  // When no filters are active → show non-spam, non-completed messages.
  // Spam filter → show only spam. Completed filter → show only completed non-spam.
  // Leads filter → show only landing-page leads (non-spam).
  const displayedMessages = allMessages.filter(m => {
    // Default inbox view (no filters active)
    if (!filterCompleted && !filterSpam && !filterLeads) {
      return !m.spam && !m.completed;
    }

    // When filters are active, only show what matches the active filters
    if (filterSpam && m.spam) return true;
    if (filterCompleted && !m.spam && m.completed) return true;
    if (filterLeads && !m.spam && m.leadType === "lead") return true;

    return false;
  });

  if (!isAuthenticated) return <Login onLogin={handleLogin} />;

  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2000,
          style: {
            background: "#161b22",
            color: "#c9d1d9",
            border: "1px solid #30363d"
          },
        }}
      />

      <header className="app-header">
        <button className="menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
        <h1>Inbox</h1>
        <div className="header-filters">
          <button
            className={`filter-btn filter-btn--lead ${filterLeads ? "active" : ""}`}
            onClick={() => setFilterLeads(v => !v)}
          >
            Leads
          </button>
          <button
            className={`filter-btn ${filterCompleted ? "active" : ""}`}
            onClick={() => setFilterCompleted(v => !v)}
          >
            Completed
          </button>
          <button
            className={`filter-btn filter-btn--spam ${filterSpam ? "active" : ""}`}
            onClick={() => setFilterSpam(v => !v)}
          >
            Spam
          </button>
        </div>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </header>

      <div className={`inbox-container ${sidebarOpen ? "show-sidebar" : ""}`}>
        {sidebarOpen && (
          <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
        )}
        <Sidebar
          messages={displayedMessages}
          onSelect={(msg) => { setSelectedMessage(msg); setSidebarOpen(false); }}
          selectedMessage={selectedMessage}
        />
        <MessageDetail
          message={selectedMessage}
          onUpdate={loadAll}
          onClear={() => setSelectedMessage(null)}
        />
      </div>
    </div>
  );
}

export default App;
